import { render, staticRenderFns } from "./StoreAccountInfo.vue?vue&type=template&id=70181c58&scoped=true&"
import script from "./StoreAccountInfo.vue?vue&type=script&lang=js&"
export * from "./StoreAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./StoreAccountInfo.vue?vue&type=style&index=0&id=70181c58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70181c58",
  null
  
)

export default component.exports